import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import useDictionary from 'lib/sitecore/use-dictionary';
import { classnames } from 'tailwindcss-classnames';
import VideoItem, { VideoItemProps } from 'components/helpers/VideoItem/VideoItem';
import ShowMoreListing from 'components/helpers/ShowMoreListing';
import EditingHelpText, { MissingDataSource } from 'components/helpers/EditingHelpText';
import { getEnumValue } from 'lib/util/enum';

export type VideoGalleryProps = Sitecore.Override.ComponentBase &
  Components.General.VideoGallery.Fields.VideoGallery & {
    fields: {
      videos: VideoItemProps[];
    };
  };

const VideoGallery = ({ fields }: VideoGalleryProps): JSX.Element => {
  const dictionary = useDictionary();

  if (!fields) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  const seeAllCtaText = dictionary.See_All_VideoGallery;
  const seeLessCtaText = dictionary.See_Less_VideoGallery;

  const videos = fields.videos.map((x) => {
    return {
      ...x,
      videoTitleHeadlineLevel: fields.videoTitleHeadlineLevel,
      videoTitleHeadlineSizing: fields.videoTitleHeadlineSizing,
    } as VideoItemProps;
  });

  const videosPerRow = parseInt(getEnumValue<string>(fields?.videosPerRow), 10);
  const columns = videosPerRow ? (videosPerRow as 1 | 2 | 3) : 2;

  return (
    <div data-component="authorable/general/videogallery">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} className={classnames('mb-4')} />
      </div>
      {!fields.videos?.length ? (
        <EditingHelpText text="Video Gallery | No Videos Selected. Note: Videos cannot be selected in Horizon and must be added from Content Editor" />
      ) : (
        ''
      )}
      <ShowMoreListing
        items={videos}
        maxInitialDisplay={fields.maxInitialDisplay.value}
        columns={columns}
        seeAllCtaText={seeAllCtaText}
        seeLessCtaText={seeLessCtaText}
        seeAllCtaVariant="secondary"
        seeAllCtaClassName={classnames('w-full', 'sm:w-fit', 'sm:block', 'm-auto')}
        component={VideoItem}
      />
    </div>
  );
};
export default VideoGallery;
